import './LinksFooter.scss';
import { Layout } from 'antd';
import React from 'react';
import { useAuthToken } from '@hooks';
import { When } from 'react-if';
import { ContactUsLink, LogoutLink, PrivacyPolicyLink, TermsOfServiceLink } from '@ui/links';
const { Footer } = Layout;
export const LinksFooter = () => {
    const { isLoggedIn } = useAuthToken();
    return (React.createElement(Footer, { className: 'links-footer' },
        React.createElement("ul", null,
            React.createElement("li", null,
                React.createElement(PrivacyPolicyLink, null)),
            React.createElement("li", null,
                React.createElement(TermsOfServiceLink, null)),
            React.createElement("li", null,
                React.createElement(ContactUsLink, null)),
            React.createElement(When, { condition: isLoggedIn },
                React.createElement("li", null,
                    React.createElement(LogoutLink, null))))));
};
